import { LineInterface } from '../lines/types';

/*
 * Action Types
 */
export enum LineLotTypes {
  LIST_LINE_LOT_REQUEST = '@lineLot/LIST_LINE_LOT_REQUEST',
  LIST_LINE_LOT_SUCCESS = '@lineLot/LIST_LINE_LOT_SUCCESS',
  LIST_LINE_LOT_FAILURE = '@lineLot/LIST_LINE_LOT_FAILURE',

  GET_LINE_LOT_REQUEST = '@lineLot/GET_LINE_LOT_REQUEST',
  GET_LINE_LOT_SUCCESS = '@lineLot/GET_LINE_LOT_SUCCESS',
  GET_LINE_LOT_FAILURE = '@lineLot/GET_LINE_LOT_FAILURE',

  FILTER_LINE_LOTS_REQUEST = '@lineLot/FILTER_LINE_LOTS_REQUEST',
  FILTER_LINE_LOTS_SUCCESS = '@lineLot/FILTER_LINE_LOTS_SUCCESS',
  FILTER_LINE_LOTS_FAILURE = '@lineLot/FILTER_LINE_LOTS_FAILURE',

  CREATE_LINE_LOT_REQUEST = '@lineLot/CREATE_LINE_LOT_REQUEST',
  CREATE_LINE_LOT_SUCCESS = '@lineLot/CREATE_LINE_LOT_SUCCESS',
  CREATE_LINE_LOT_FAILURE = '@lineLot/CREATE_LINE_LOT_FAILURE',

  ADD_LINE_LOT_REQUEST = '@lineLot/ADD_LINE_LOT_REQUEST',
  ADD_LINE_LOT_SUCCESS = '@lineLot/ADD_LINE_LOT_SUCCESS',
  ADD_LINE_LOT_FAILURE = '@lineLot/ADD_LINE_LOT_FAILURE',

  UPDATE_LINE_LOT_REQUEST = '@lineLot/UPDATE_LINE_LOT_REQUEST',
  UPDATE_LINE_LOT_SUCCESS = '@lineLot/UPDATE_LINE_LOT_SUCCESS',
  UPDATE_LINE_LOT_FAILURE = '@lineLot/UPDATE_LINE_LOT_FAILURE',

  DELETE_LINE_LOT_REQUEST = '@lineLot/DELETE_LINE_LOT_REQUEST',
  DELETE_LINE_LOT_SUCCESS = '@lineLot/DELETE_LINE_LOT_SUCCESS',
  DELETE_LINE_LOT_FAILURE = '@lineLot/DELETE_LINE_LOT_FAILURE',
}

/*
 * Data types
 */

export interface LineLotInterface {
  id: string;
  name: string;
  color: string;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
  Lines?: LineInterface[];
}

/*
 * State type
 */
export interface LineLotState {
  readonly lineLotList: LineLotInterface[];
  readonly lineLotData: LineLotInterface;
  readonly lineLotAdded: LineInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
